import React, { useState } from "react";
import { UserType } from "#/api/oidc/oidcConfig";
import { useOidc, useOidcUser } from "@axa-fr/react-oidc";
import { Button, Icon, DropdownMenu } from "@sicredi/react";
import styles from "./styles.module.scss";
import getFirstName from "#/utils/getFirstName";
import LogoutConfirmation from "../Modals/LogoutConfirmation";

export default function Auth() {
  const { logout } = useOidc();
  const { oidcUser } = useOidcUser<UserType>();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [logoutModalOpen, setLogoutModalOpen] = useState<boolean>(false);

  return (
    <>
      <LogoutConfirmation
        logout={logout}
        logoutModalOpen={logoutModalOpen}
        setLogoutModalOpen={setLogoutModalOpen}
      />
      <div data-testid="auth" className={styles["button-area"]}>
        <div className={styles["button-login"]}>
          <Button className={styles["button-icon"]}>
            <Icon size={16} name="user" color={"#3FA111"} />
          </Button>
          <div className={styles["login-text"]}>
            <div className={styles["welcome"]}>
              <div className={styles["usergreeting"]}>
                Olá, {getFirstName(oidcUser?.name)}
              </div>
              <DropdownMenu
                aria-label="Menu de exemplo"
                triggerProps={{
                  children: isOpen ? (
                    <Icon name="chevron-up" appearance="primary" />
                  ) : (
                    <Icon name="chevron-down" appearance="primary" />
                  ),
                }}
                className={styles["dropdown"]}
                onClick={() => (isOpen ? setIsOpen(false) : setIsOpen(true))}
              >
                <DropdownMenu.Item
                  onClick={() => setLogoutModalOpen(true)}
                  data-testid="button-logout"
                  className={styles["dropdownitem"]}
                >
                  Sair
                </DropdownMenu.Item>
              </DropdownMenu>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
